import { useContext, Fragment, type ReactElement } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { layer, radius, fontSize } from '../../../../../common/css/setting/variable';
import SearchHelper from '../../../../../common/search/SearchHelper';

const Main = styled.button`
  padding: 4px 8px;
  text-align: left;
`;

const Text = styled.span`
  font-size: ${fontSize.px14};
`;

const Wrap = styled.div`
  position: absolute;
  top: 27px;
  left: 0;
  z-index: ${layer.overlay_common};
  width: 282px;
  margin-left: 12px;
  background-color: ${props => props.theme.news.palette.bg_lv1_common};
  border: 1px solid ${props => props.theme.news.palette.btn_simple_border_common};
  border-radius: ${radius.searchBottom_pc};
  transform: translateZ(0); /* safariでサジェストが重なるため指定 */
`;

const ListBody = styled.ul`
  z-index: ${layer.modal_common};
  margin: 4px 0;
  overflow: hidden;
  cursor: pointer;
`;

interface IProps {
  isOpen: boolean;
  query: string;
  suggestList: string[];
  selectedSuggestIndex: number;
  setSearchWord: (word: string) => void;
  setSelectedSuggestIndex: (index: number) => void;
}

const SearchBoxSuggest = (props: IProps): ReactElement => {
  /**
   * サジェスト文字列の始まりが検索窓の文字と同じ場合はそこだけStrongにしないようにして返す
   *
   * @param suggestWord
   */
  const decorateSuggestWord = (suggestWord: string) => {
    if (!props.query) {
      return null;
    }
    const trimmedQuery = SearchHelper.normalizeWord(props.query);
    if (suggestWord.indexOf(trimmedQuery) === 0) {
      return (
        <Fragment>
          {trimmedQuery}
          <strong>{suggestWord.substring(trimmedQuery.length)}</strong>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <strong>{suggestWord}</strong>
      </Fragment>
    );
  };

  const handleMouseOver = (index: number) => {
    props.setSelectedSuggestIndex(index);
  };

  const themeContext = useContext(ThemeContext);

  // サジェストリスト
  const list = props.suggestList
    ? props.suggestList.map((suggestWord, index) => (
        <li
          key={index + 1}
          style={
            props.selectedSuggestIndex === index
              ? { backgroundColor: `${themeContext?.news.palette.bg_lv2_common}` }
              : { backgroundColor: `${themeContext?.news.palette.bg_lv1_common}` }
          }
          onMouseDown={() => {
            // aqパラメータを付けるためにイベント伝搬させずにここで遷移させる
            props.setSearchWord(suggestWord);
            window.location.href = `${SearchHelper.createNewsSearchUrl(suggestWord)}&aq=${index}`;
          }}
          onMouseOver={() => handleMouseOver(index)}
        >
          <Main>
            <Text>{decorateSuggestWord(suggestWord)}</Text>
          </Main>
        </li>
      ))
    : [];

  return (
    <Wrap>
      <ListBody>{list}</ListBody>
    </Wrap>
  );
};
export default SearchBoxSuggest;
